import { isLocalhost } from '../fhg/utils/Utils'
import { registerServiceWorkerPromise } from '../index'

// Version checking interval configuration
export const MAX_INTERVAL =
    window.location.hostname === 'dev3.heavyworth.com'
        ? 2 * 61 * 1000
        : isLocalhost
          ? Number.MAX_SAFE_INTEGER - 1
          : 5 * 60 * 1000

// Version checking logic
export const checkVersions = async (currentVersion, onVersionMismatch) => {
    if (!isLocalhost) {
        try {
            const resp = await fetch('/service-worker.js', {
                method: 'HEAD',
                cache: 'no-store',
                headers: { 'cache-control': 'no-cache', pragma: 'no-cache' },
            })
            const etag =
                resp.headers.get('etag') ||
                resp.headers.get('last-modified') ||
                '';
            const prev = localStorage.getItem('sw_etag') || ''
            if (etag && prev && etag !== prev) {
                onVersionMismatch(etag)
                console.log(
                    `Versions do not match. Current version - ${currentVersion}. New Version - ${etag}`
                )
            }
            if (!prev && etag) {
                localStorage.setItem('sw_etag', etag)
            }
        } catch (e) {
            console.log("Error fetching service worker.js", e);
        }
    }
}

// Service worker update logic
export const updateServiceWorkers = () => {
    if (navigator.serviceWorker) {
        navigator.serviceWorker
            .getRegistrations()
            .then((registrations) => {
                for (const registration of registrations) {
                    registration.update()
                }
            })
    }
}

// Initialize version checking with service worker updates
export const initializeVersionChecking = (checkVersionsCallback, currentVersion, onVersionMismatch) => {
    if (!isLocalhost) {
        fetch('/service-worker.js', {
            method: 'HEAD',
            cache: 'no-store',
            headers: { 'cache-control': 'no-cache', pragma: 'no-cache' },
        })
            .then((resp) => {
                const etag =
                    resp.headers.get('etag') ||
                    resp.headers.get('last-modified') ||
                    ''
                if (etag) {
                    localStorage.setItem('sw_etag', etag)
                }
            })
        const interval = setInterval(() => {
            checkVersionsCallback()
            updateServiceWorkers()
        }, MAX_INTERVAL)

        registerServiceWorkerPromise.then((result) => {
            console.log(
                `Service worker is updating. Current version - ${currentVersion}.`
            )
            checkVersionsCallback()
        })

        return interval
    }
    return null
}